import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { makeStyles, MenuItem } from '@material-ui/core';
import { TextField } from '@avangard/ui/core';

import { usePageFilters } from '@modules/shared/organisms';
import { useCourses } from '@modules/courses/hooks';

import type { StudentPerformanceStatsFilters } from '@modules/students/hooks';

const usePopoverClasses = makeStyles({
    paper: {
        maxWidth: 420,
    },
});

const Filters = styled.div`
    display: flex;
    flex-wrap: wrap;

    max-width: 420px;

    > * {
        min-width: 200px;
    }
`;

const MenuItemContent = styled.span`
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
`;

const ToolbarFilters = (): React.ReactElement => {
    const { t } = useTranslation(['common']);

    const popoverClasses = usePopoverClasses();

    const { filters, handleChange } = usePageFilters<StudentPerformanceStatsFilters>();

    const { courses, loading: coursesLoading } = useCourses();

    return (
        <Filters>
            <TextField
                select
                fullWidth
                id='courseId'
                name='courseId'
                disabled={coursesLoading}
                value={filters.courseId}
                onChange={handleChange}
                SelectProps={{
                    MenuProps: {
                        PopoverClasses: popoverClasses,
                    },
                }}
            >
                <MenuItem disabled value=''>
                    {t('common:forms.placeholder.choose_course')}
                </MenuItem>

                {courses.map(course => (
                    <MenuItem key={course.id} value={course.id}>
                        <MenuItemContent>{course.name}</MenuItemContent>
                    </MenuItem>
                ))}
            </TextField>
        </Filters>
    );
};

export { ToolbarFilters };
